export default __webpack_public_path__ + "static/media/Experience Selector.1b17b150.svg";